export default __webpack_public_path__ + "static/media/recarga-tiempo-aire.c918cdfe.png";